declare global {
	interface Window {
		epmsUiEnv?: DeploymentEnv;
		epmsApiEnv?: string;
	}
}

export type DeploymentEnv = 'prod' | 'stage' | 'canary';

export function resolveAppEnv({ standaloneProdUrl }: { standaloneProdUrl: string }) {
	function resolveApiEnv(): DeploymentEnv {
		if (!window.epmsApiEnv) return resolveStandaloneEnv();

		const isProd = ['gcpstg', 'gcpprd'].includes(window.epmsApiEnv);

		return isProd ? 'prod' : 'stage';
	}

	function resolveStandaloneEnv(): DeploymentEnv {
		const isProd = window.location.hostname.includes(standaloneProdUrl);
		return isProd ? 'prod' : 'stage';
	}

	function resolveDeploymentEnv(): DeploymentEnv {
		if (!window.epmsUiEnv) return resolveStandaloneEnv();

		return window.epmsUiEnv;
	}

	function isStandalone(): boolean {
		return window.epmsUiEnv === undefined;
	}

	return {
		deploymentEnv: resolveDeploymentEnv(),
		isProduction: ['prod', 'canary'].includes(resolveDeploymentEnv()),
		shouldUseProdApi: resolveApiEnv() === 'prod',
		isStandalone,
	};
}
